export const story = {
	name: 'Untitled Story Template',
	variant: 'design',
	json: {
		width: 1080,
		height: 1920,
		fonts: [],
		pages: [
			{
				id: 'page_1',
				children: [],
				width: 'auto',
				height: 'auto',
				background: 'white',
				bleed: 0,
			},
		],
		unit: 'px',
		dpi: 96,
	},
	status: 'draft',
	history: [],
	tags$Category: [],
	tags$General: [
		'0:Medium:Digital',
		'0:Distribution:Social',
		'0:Format:Story',
		'0:Format:Reel',
		'0:Format:Post',
		'0:Layout:Portrait',
		'0:Dimensions:1080x1920',
		'0:Network:Facebook',
		'0:Network:Instagram',
	],
	etc: {
		directives: {},
		cfg: {
			global: {
				minPages: 1,
				maxPages: 50,
			},
			customer: {
				minPages: 1,
				maxPages: 50,
			},
			order: {
				countries: null,
				itemId: 'story',
			},
			canBeResized: true,
		},
	},
};

export default story;
